import * as React from "react";
import { isBrowser } from "@montana/helpers/browser.helper";

export interface ISvgIconProps {
    iconName?: string;
    iconBody?: string;
    className?: string;
}

export const SvgIcon: React.FC<ISvgIconProps> = React.memo((props: ISvgIconProps): JSX.Element => {
    const { iconName, iconBody, className = "" } = props;

    try {
        const svgContent = iconBody || require(`../../../assets/icons/${iconName}.svg`);
        return <span className={`svg-icon ${className}`.trim()} dangerouslySetInnerHTML={{ __html: svgContent }} aria-hidden />;
    } catch (e) {
        if (isBrowser) {
            window.console.warn(e);
        }
    }
    return <></>;
});
